import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div className="h-screen overflow-y-auto bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 p-6 md:p-12 lg:py-24 flex justify-center">
      <div className="w-full max-w-4xl bg-white dark:bg-gray-800 rounded-3xl shadow-xl p-8 md:p-12 h-fit">
        <div className="mb-8 flex items-center justify-between">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">Terms and Conditions</h1>
          <Link to="/signin" className="text-blue-600 dark:text-blue-400 hover:underline flex items-center font-medium">
            <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
            Back to Sign in
          </Link>
        </div>
        <div className="space-y-6 text-gray-700 dark:text-gray-300">
          <p className="font-semibold text-sm">Last Updated: January 07, 2022</p>

          <p>This Privacy Policy explains our policies and procedures on the collection, use, and disclosure of your information when you use our Service. It also outlines your privacy rights and how the law protects you.</p>

          <p>We use your personal data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this Privacy Policy.</p>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Interpretation and Definitions</h3>
          <h4 className="font-medium text-gray-800 dark:text-gray-200">Interpretation</h4>
          <p>Words with an initial capital letter have meanings defined in the following conditions. The definitions apply regardless of whether they appear in singular or plural form.</p>

          <h4 className="font-medium text-gray-800 dark:text-gray-200">Definitions</h4>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Account</strong> – A unique account created for you to access our Service.</li>
            <li><strong>Company</strong> – Infinity Solution, 303, Emerald Complex, Chimanlal Girdharlal Rd, above Karnavati Pagarkha bazar, Mithakhali, Navrangpura, Ahmedabad, Gujarat 380009</li>
            <li><strong>Cookies</strong> – Small files placed on your device containing browsing history and other usage data.</li>
            <li><strong>Country</strong> – Gujarat, India.</li>
            <li><strong>Device</strong> – Any device that can access the Service such as a computer, mobile phone, or tablet.</li>
            <li><strong>Personal Data</strong> – Any information that identifies or can identify an individual.</li>
            <li><strong>Service</strong> – The website Infinity Solution.</li>
            <li><strong>Service Provider</strong> – Any party processing data on behalf of the Company.</li>
            <li><strong>Usage Data</strong> – Data collected automatically from the Service usage or infrastructure.</li>
            <li><strong>You</strong> – The individual using the Service or the legal entity they represent.</li>
          </ul>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Collecting and Using Your Personal Data</h3>
          <h4 className="font-medium text-gray-800 dark:text-gray-200">Types of Data Collected</h4>
          <h5 className="font-medium">Personal Data</h5>
          <p>While using our Service, we may collect the following personally identifiable information:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Email address</li>
            <li>First and last name</li>
            <li>Phone number</li>
          </ul>

          <h5 className="font-medium">Usage Data</h5>
          <p>Usage Data is collected automatically and may include your IP address, browser type/version, visited pages, visit time/date, time spent on pages, and device identifiers. When using a mobile device, additional data such as device type, OS, and browser type may be collected.</p>

          <h4 className="font-medium text-gray-800 dark:text-gray-200">Tracking Technologies and Cookies</h4>
          <p>We use cookies, beacons, tags, and scripts to track activity and improve our Service.</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Necessary Cookies</strong> – Required for the website’s functionality.</li>
            <li><strong>Cookies Policy/Notice Acceptance Cookies</strong> – Remember if you’ve accepted cookie use.</li>
            <li><strong>Functionality Cookies</strong> – Store preferences such as login details or language.</li>
          </ul>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Use of Your Personal Data</h3>
          <p>We may use your Personal Data to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide and maintain the Service</li>
            <li>Manage your account</li>
            <li>Fulfill contracts and process purchases</li>
            <li>Contact you via email, phone, or SMS</li>
            <li>Send promotional offers and updates</li>
            <li>Manage your requests</li>
          </ul>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Retention of Data</h3>
          <p>We retain your Personal Data only as long as necessary for the purposes stated in this policy or as required by law.</p>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Security of Data</h3>
          <p>We use commercially acceptable means to protect your Personal Data but cannot guarantee absolute security.</p>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Children’s Privacy</h3>
          <p>We do not knowingly collect data from individuals under the age of 13. If you believe a child has provided us with data, please contact us immediately.</p>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Changes to This Privacy Policy</h3>
          <p>We may update this policy from time to time and will notify you of significant changes.</p>

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mt-6">Contact Us</h3>
          <p>If you have any questions about this Privacy Policy, contact us at:</p>
          <p>Email: mitul@infisms.com</p>
        </div>
      </div>
    </div>
  );
}
